<template>
    <div ref="pointContainer">
        <div v-if="!loading && sum > 0"
                class="flex flex-col w-full">
            <div    class="flex flex-row w-full rounded-md overflow-hidden"
                    :class="height"
                    :style="{ height: this.height }">
                <!-- Good Bar -->
                <div    v-if="good > 0"
                        class="flex flex-wrap items-center whitespace-nowrap overflow-hidden border-solid border-2 border-green-500 bg-green-300 inline-block p-0"
                        :class="height"
                        :style="{ width: this.widthGood }"
                        :data-tippy-content="goodText">
                </div>

                <!-- Caution Bar -->
                <div    v-if="caution > 0"
                        class="border-solid whitespace-nowrap overflow-hidden border-2 border-yellow-300 bg-yellow-100 inline-block p-0"
                        :class="height"
                        :style="{ width: this.widthCaution }"
                        :data-tippy-content="cautionText">
                </div>

                <!-- Alarm Bar -->
                <div    v-if="alarm > 0"
                        class="border-solid whitespace-nowrap overflow-hidden border-2 border-red-500 bg-red-300 inline-block p-0"
                        :class="height"
                        :style="{ width: this.widthAlarm }"
                        :data-tippy-content="alarmText">
                </div>

                <!-- Offline Bar -->
                <div    v-if="offline > 0"
                        class="border-solid whitespace-nowrap overflow-hidden border-2 border-gray-500 bg-gray-300 inline-block p-0"
                        :class="height"
                        :style="{ 'width': this.widthOffline }"
                        :data-tippy-content="offlineText">
                </div>
            </div>

            <!-- Legend -->
            <div    v-if="false"
                    class="hidden md:flex flex-row justify-between lg:justify-around py-1">
                <div class="flex flex-col">
                    <!-- In Range -->
                    <div    v-if="good > 0"
                            class="flex flex-row items-center py-1">
                        <span class="p-3 border-solid border-2 border-green-500 bg-green-300 rounded-md"></span>
                        <span class="pl-1">
                            {{ goodText }}
                        </span>
                    </div>

                    <!-- Caution -->
                    <div    v-if="caution > 0"
                            class="flex flex-row items-center py-1">
                        <span class="p-3 border-solid border-2 border-yellow-300 bg-yellow-100 rounded-md"></span>
                        <span class="pl-1">
                            {{ cautionText }}
                        </span>
                    </div>
                </div>

                <div class="flex flex-col">
                    <!-- Alarm -->
                    <div    v-if="alarm > 0"
                            class="flex flex-row items-center py-1">
                        <span class="p-3 border-solid border-2 border-red-500 bg-red-300 rounded-md"></span>
                        <span class="pl-1">
                            {{ alarmText }}
                        </span>
                    </div>

                    <!-- Offline -->
                    <div    v-if="offline > 0"
                            class="flex flex-row items-center py-1">
                        <span class="p-3 border-solid border-2 border-gray-500 bg-gray-300 rounded-md"></span>
                        <span class="pl-1">
                            {{ offlineText }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="loading"
             class="flex flex-row items-center justify-center text-base text-center">
            <span>loading</span>
        </div>
        <div v-else
             class="flex flex-row items-center justify-center text-base text-center">
            <span>No Points Found</span>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js';

const MAX_WIDTH = 100

export default {
    name: "PointStatus",
    props: {
        info: Object,
    },
    data() {
        return {
            loading: false,
            height: 'h-8',
            tippyInstance: null,
        }
    },
    created() {
    },
    mounted() {
        this.tippyInstance = tippy('[data-tippy-content]')
    },
    methods: {

    },
    computed: {
        good() {
            return this.info.green
        },
        caution() {
            return this.info.yellow
        },
        alarm() {
            return this.info.red
        },
        offline() {
            return this.info.offline
        },
        goodText() {
            return `${this.good} points in range`
        },
        cautionText() {
            return `${this.caution} points in caution`
        },
        alarmText() {
            return `${this.alarm} points in alarm`
        },
        offlineText() {
            return `${this.offline} points are offline`
        },
        sum() {
            return this.good + this.caution + this.alarm + this.offline
        },
        widthGood() {
            return (this.good / this.sum * MAX_WIDTH) + '%'
        },
        widthCaution() {
            return (this.caution / this.sum * MAX_WIDTH) + '%'
        },
        widthAlarm() {
            return (this.alarm / this.sum * MAX_WIDTH) + '%'
        },
        widthOffline() {
            return (this.offline / this.sum * MAX_WIDTH) + '%'
        },
        width() {
            return MAX_WIDTH + '%'
        },
    },
    beforeUnmount() {
    },
}

</script>
